<template>
    <div>
        <el-dialog :visible="true" :top="'5vh'" width="80%" @close="$emit('close')" class="manageForm" v-loading="pageLoading" :close-on-click-modal="false">

            <div class="w-100p" v-if="!pageLoading">
                <!-- 基本信息 -->
                <div>
                    <el-form ref="form1" class="contract_form" :model="form" :rules="rules1" size="small" label-width="100px" label-position="top">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="合同编号" prop="contract_no">
                                    <el-input v-model="form.contract_no"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="24">
                                <el-divider content-position="left"><span class="is-required-text">租赁位置</span></el-divider> </el-col>
                            <el-col class="mar-t-10" :span="24">
                                <el-table :data="selectRoomList" size="small" border>
                                    <el-table-column type="index" width="50">
                                        <template slot="header">
                                            <el-button size="mini" @click="addSelectRoomList()" type="primary" icon="el-icon-plus" circle></el-button>
                                        </template>
                                        <template slot-scope="scope">
                                            <el-button size="mini" @click="selectRoomList.splice(scope.$index , 1);calculateRoom();calculate();" type="danger" icon="el-icon-minus" circle></el-button>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="楼宇" width="200px">
                                        <template slot-scope="scope">

                                            <el-select class="dis-b" size="small" filterable v-model="scope.row.building" @change="roomSelectChange(scope.row , 'building');getFloor(scope.$index)">
                                                <el-option v-for="item of dictData.building" :key="item.id" :value="item.id" :label="item.name"></el-option>
                                            </el-select>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="楼层" width="150px">
                                        <template slot-scope="scope">
                                            <el-select :placeholder="scope.row.building ? '请选择' : '请先选择楼宇'" class="dis-b" size="small" filterable v-model="scope.row.floor"
                                                       @change="roomSelectChange(scope.row , 'floor');getRoom(scope.$index)">
                                                <el-option v-for="item of scope.row.floorData" :key="item.id" :value="item.id" :label="item.name"></el-option>
                                            </el-select>

                                        </template>
                                    </el-table-column>
                                    <el-table-column label="房间">
                                        <template slot-scope="scope">
                                            <el-row type="flex">
                                                <el-col class="w-80 lh-30 text-center mar-0 pad-0">
                                                    <el-link type="primary" :underline="false" @click="selectAllRoom(scope.row , scope.$index)">选中整层</el-link>
                                                    <el-divider direction="vertical"></el-divider>
                                                </el-col>
                                                <el-col :span="1" class="w-100p pad-0">
                                                    <el-cascader class="dis-b w-100p" :key="scope.row.floor" v-model="scope.row.room" @change="roomSelectChange(scope.row , 'room')" size="small"
                                                                 :options="scope.row.roomData" :props="{multiple: true , label: 'name' , value: 'id' , emitPath: false , checkStrictly: true}" clearable
                                                                 filterable>
                                                    </el-cascader>
                                                </el-col>
                                            </el-row>

                                        </template>
                                    </el-table-column>
                                </el-table>
                                <div v-if="selectRoomListError" style="position: static" class="el-form-item__error">请选择租赁位置</div>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="租赁面积(㎡)" prop="rent_area">
                                    <el-input placeholder="请输入" type="number" v-model.number="form.rent_area"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="租金总额(元)" prop="amount">
                                    <el-input placeholder="请输入" type="number" v-model.number="form.amount"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col class="mar-tb-10" :span="24">
                                <el-divider content-position="left">租客信息</el-divider>
                            </el-col>
                            <!-- <el-col :span="6">
                                <el-form-item label="租客类型" prop="renters_type">
                                    <el-input v-model="form.renters_type" disabled></el-input>
                                </el-form-item>
                            </el-col> -->
                            <el-col :span="6">
                                <el-form-item label="入驻企业" prop="company_id">
                                    <model-search-select v-model="form.company_id" model="wp_company" :fillModel.sync="form" :fills="[
                      {target: 'renters_name' , source: 'name'},
                      {target: 'corporation_personality' , source: 'legal_person'},
                      {target: 'corporation_personality_contact' , source: 'legal_contact'}
                    ]" @change="getReductionPolicy()">
                                        <template slot="empty">
                                            <div class="pad-tb-15 text-center fts-14">
                                                <div v-if="!loading.enterpriseLoading">
                                                    <span>暂无企业，去</span>
                                                    <!-- <span class="cur-p text-blue" @click="enterpriseDrawer = true">添加</span> -->
                                                </div>
                                            </div>
                                        </template>
                                    </model-search-select>

                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="企业法人" prop="corporation_personality">
                                    <el-input v-model="form.corporation_personality" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="法人联系方式" prop="corporation_personality_contact">
                                    <el-input v-model="form.corporation_personality_contact" disabled></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="签订人" prop="renters_signed">
                                    <el-input v-model="form.renters_signed"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="签订人联系方式" prop="renters_signed_contact">
                                    <el-input v-model="form.renters_signed_contact"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系地址" prop="renters_address">
                                    <el-input v-model="form.renters_address"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col class="mar-tb-10" :span="24">
                                <el-divider content-position="left">租赁时间</el-divider>
                            </el-col>

                            <el-col :span="6">
                                <el-form-item label="开始日期" prop="start_time">
                                    <el-date-picker class="w-100p" value-format="yyyy-MM-dd"
                                                    @change="(form.rent_date_type == 1 && calculateEndData('start_date' , 'end_date' , 'rent_period'));calculateRoomDate();calculate();"
                                                    v-model="form.start_time" type="date" placeholder="年 / 月 / 日"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                                <el-form-item label="结束日期" prop="end_time">
                                    <el-date-picker @change="form.rent_date_type == 1 ? null : calculate();calculateRoomDate();" :picker-options="pickerOptions" class="w-100p"
                                                    value-format="yyyy-MM-dd" v-model="form.end_time" type="date" placeholder="年 / 月 / 日"></el-date-picker>
                                </el-form-item>
                            </el-col>

                        </el-row>

                    </el-form>
                </div>

            </div>
            <div slot="footer" class="text-left bor-t pad-tb-8 pad-lr-15 ov-h">

                <div class="pull-right mar-l-10">
                    <el-button size="small" v-if="active === 1" @click="$emit('close')">取消</el-button>
                    <el-button size="small" v-if="active > 1 && !editMoney" @click="active--">上一步</el-button>
                    <el-button size="small" v-if="editMoney" @click="cancelEditMoney()">取消</el-button>
                </div>
                <div class="pull-right text-right">
                    <el-button size="small" :loading="saveLoading" @click="saveMetaCommon()" type="primary">提交</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import dayjs from 'dayjs';
import { startFlow } from '@/api/flow/flow.js';
import {
    getMetaCommonList,
    delMetaCommon,
    saveMetaCommon,
    updateMetaCommon,
    getMetaCommonInfo,
    getMetaCommonListExport,
    getMetaCommonDetail,
} from '@/api/busiMode/metaCommon';

import { save, update, detail, calculate, queryCollectionPlan, countDepositAmount } from '@/api/contract/index.js';
import { getDictionary } from '@/api/system/dictbiz.js';
import mathjs from '@/util/math.js';

window.mathjs = mathjs;
window.dayjs = dayjs;

export default {
    components: {},
    data() {
        return {
            editMoney: false,
            dayjs: dayjs,
            saveLoading: false,
            pageLoading: true,
            loading: {
                staffLoading: false,
                enterpriseLoading: false,
                templateLoading: false,
            },
            enterpriseDrawer: false,
            active: 1,
            cache: {
                company_name: '',
            },
            form: {},
            rules1: {
                code: [{ required: true, message: '请输入合同编号', trigger: 'blur' }],

                lessor_signed_contact: [{ required: true, message: '请输入甲方签订人联系方式', trigger: 'blur' }],
                company_id: [{ required: true, message: '请选择入驻企业', trigger: 'blur' }],

                rent_period: [{ required: true, message: '请输入租赁时间', trigger: 'blur' }],
                start_date: [{ required: true, message: '请选择租赁开始日期', trigger: 'blur' }],
                end_date: [{ required: true, message: '请选择租赁结束日期', trigger: 'blur' }],
                signed_date: [{ required: true, message: '请选择签定日期', trigger: 'blur' }],
            },
            rules2: {
                amount: [{ required: true, message: '请输入租金总额', trigger: 'blur' }],
                payment_type: [{ required: true, message: '请选择付款方式', trigger: 'blur' }],
                collection_account_id: [{ required: true, message: '请选择收款账户', trigger: 'blur' }],
            },
            dictData: {
                contract_attribute: [],
                offer_type: [],
                payment_type: [],
                building: [],
                staff: [],
                enterprise: [],
                collection_account: [],
                template: [],
                preferential_way: [
                    { name: '优惠政策', value: 1 },
                    { name: '自定义策略', value: 2 },
                ],
                frequency_unit: [],
                receipt_strategy: [],
                contract_type: [],
                property_fee_way: [],
                deposit_pay_status: [],
            },
            roomSelectSwitch: true,
            selectRoomList: [],
            oldSelectRoomList: [],
            selectRoomListError: false,
            roomSelectedError: false,
            roomSelected: [],
            amountList: [],
            feeData: { deposit: [], rent: [] },
            pickerOptions: {
                disabledDate: time => {
                    let start_time = dayjs(this.form.start_date).valueOf();
                    return time.getTime() < start_time;
                },
            },
            pickerOptions1: {
                disabledDate: time => {
                    let start_time = Date.now();
                    return time.getTime() > start_time;
                },
            },
            initRelations: [
                // {code: 'company_id' , model: 'wp_company' , prop: 'enterprise'},
                { code: 'lessor_signed', model: 'wp_employee', prop: 'staff' },
            ],
            reductionPolicy: [],
            showAddReductionPolicy: false,
        };
    },
    props: {
        type: {
            type: String,
            default: 'add',
        },
        model: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: '',
        },
        contractType: {
            type: String,
            default: '',
        },
    },
    computed: {
        isBusiness() {
            console.log(this.form.contract_type);
            return Number(this.contractType ? this.contractType : this.form.contract_type) === 2 ? true : false;
        },
        formTitle() {
            if (this.type === 'add' || this.type === 'template') {
                return '新增合同';
            }
            if (this.type === 'edit') {
                return '编辑合同';
            }
            if (this.type === 'relet') {
                return '续签合同';
            }
            return '';
        },
        isEdit() {
            return this.type === 'edit' ? true : false;
        },
        isRelet() {
            return this.type === 'relet' ? true : false;
        },
        isTemplate() {
            return this.type === 'template' ? true : false;
        },
    },
    mounted() {
        this.getDictData();
        if (this.id) {
            this.getDetail();
        } else {
            this.form.contract_type = this.contractType;
            this.pageLoading = false;
        }
    },
    methods: {
        saveMetaCommon() {
            if (this.form.id) {
                let o = {
                    update: this.form,
                    primaryKeyValue: this.form['id'],
                    primaryKey: 'id',
                };
                updateMetaCommon('wisdom_park.wp_sublessor_contract', o).then(res => {
                    if (res.data.code == 200) {
                        this.saveLoading = false;

                        let pk = 'id';
                        let ids = [];
                        this.oldSelectRoomList.forEach(e => {
                            console.log(e);
                            if (e.id) {
                                ids.push(e.id);
                            }
                        });
                        delMetaCommon('wisdom_park.wp_sublessor_contract_subject', { pk: pk, ids: ids }).then(res => {
                            new Promise((resolve, reject) => {
                                this.selectRoomList.forEach((e, i) => {
                                    console.log(e);
                                    let room_name = '';
                                    // e.room = e.room.split(',');
                                    // e.room.forEach(id => {
                                    e.roomData.forEach(room => {
                                        if (e.room == room.id) {
                                            room_name = room_name + room.name;
                                        }
                                    });
                                    //});
                                    let value = {
                                        room_id: e.room.toString(),
                                        building_id: e.building,
                                        floor_id: e.floor,
                                        room_name: room_name,
                                        floor_name: e.floorName,
                                        building_name: e.buildingName,
                                        sublessor_contract_id: this.form.id,
                                    };
                                    saveMetaCommon('wisdom_park.wp_sublessor_contract_subject', {
                                        values: value,
                                    }).then(res => {
                                        if (i + 1 == this.selectRoomList.length) {
                                            console.log('借助');
                                            this.saveLoading = false;
                                            this.$message.success('保存成功');
                                            this.$emit('save');
                                        }
                                    });
                                });
                            }).then(res => {});
                        });
                        this.$emit('save');
                    }
                });
            } else {
                delete this.form.contract_type;
                saveMetaCommon('wisdom_park.wp_sublessor_contract', {
                    values: this.form,
                }).then(res => {
                    if (res.data.code == 200) {
                        new Promise((resolve, reject) => {
                            this.selectRoomList.forEach((e, i) => {
                                let room_name = '';
                                e.room.forEach(id => {
                                    e.roomData.forEach(room => {
                                        if (id == room.id) {
                                            room_name = room_name + room.name;
                                        }
                                    });
                                });
                                let value = {
                                    room_id: e.room.toString(),
                                    building_id: e.building,
                                    floor_id: e.floor,
                                    room_name: room_name,
                                    floor_name: e.floorName,
                                    building_name: e.buildingName,
                                    sublessor_contract_id: res.data.data.id,
                                };
                                saveMetaCommon('wisdom_park.wp_sublessor_contract_subject', {
                                    values: value,
                                }).then(res => {
                                    if (i + 1 == this.selectRoomList.length) {
                                        console.log('借助');
                                        this.saveLoading = false;
                                        this.$message.success('保存成功');
                                        this.$emit('save');
                                    }
                                });
                            });
                        }).then(res => {});
                    }
                });
            }
        },
        removeFeeDataItem(index, typeName) {
            this.feeData[typeName].splice(index, 1);
            this.feeData[typeName].forEach((item, index) => {
                item.name = `第${index + 1}期`;
            });
        },
        feeDataTableTimeChange(ev, row) {
            if (ev && ev.length) {
                row.startTime = `${ev[0]} 00:00:00`;
                row.endTime = `${ev[1]} 23:59:59`;
            }
        },
        addFeeData(typeName) {
            this.feeData[typeName] = this.feeData[typeName] || [];
            this.feeData[typeName].push({
                name: `第${this.feeData[typeName].length + 1}期`,
                receivableDate: '',
                startTime: '',
                endTime: '',
                amountReceivable: 0,
                collectionItem: typeName,
                days: 0,
                propertyManagementFeeTotal: 0,
                times: [],
            });
        },
        clearFeeData() {
            this.feeData['deposit'] = [];
            this.feeData['rent'] = [];
        },
        countDepositAmount() {
            this.$nextTick(() => {
                countDepositAmount({
                    contractNo: this.form.deposit_resource,
                }).then(res => {
                    this.form.deposit_amount = res.data.data;
                });
            });
        },
        depositPayStatusChange() {
            if (this.form.deposit_pay_status == 2) {
                this.form.deposit_type = '1';
            }
        },
        selectAllRoom(row, index) {
            let rooms = [].concat(row.room);
            let handle = data => {
                data.forEach(room => {
                    if (room.disabled != true) {
                        if (row.room.includes(room.id) === false) {
                            if (room.children) {
                                handle(room.children);
                            } else {
                                rooms.push(room.id);
                            }
                        }
                    }
                });
            };
            handle(row.roomData);
            if (row.room.length !== rooms.length) {
                row.room = rooms;
                this.roomSelectChange(row, 'room');
            }
            // if(change > 0){
            //   this.roomSelectChange(row , 'room');
            // }
        },
        calculateRoomDate() {
            let start = this.form.start_date ? dayjs(this.form.start_date).valueOf() : 0;
            let end = this.form.end_date ? dayjs(this.form.end_date).valueOf() : 0;
            if (start && end) {
                this.roomSelected.forEach(item => {
                    // let itemStart = item.start_date ? dayjs(`${item.start_date} 00:00:00`).valueOf() : 0;
                    // let itemEnd = item.end_date ? dayjs(`${item.end_date} 23:59:59`).valueOf() : 0;
                    item.start_date = dayjs(this.form.start_date).format('YYYY-MM-DD');
                    // if(itemStart < start || itemStart > end){
                    //   item.start_date = dayjs(this.form.start_date).format('YYYY-MM-DD');
                    // }
                    item.end_date = dayjs(this.form.end_date).format('YYYY-MM-DD');
                    // if(itemEnd > end || itemEnd < start){
                    // item.end_date = dayjs(this.form.end_date).format('YYYY-MM-DD');
                    // }
                });
            }
        },
        roomDatePickerPropsDisabledDate(type, row, time) {
            let Time = time.getTime();
            let startDate = dayjs(this.form.start_date).valueOf();
            let endDate = dayjs(this.form.end_date).valueOf();
            if (type === 'end') {
                startDate = dayjs(row.start_date).valueOf();
            }
            return Time < startDate || Time > endDate;
        },
        addSelectRoomList() {
            this.selectRoomList.push({
                building: '',
                buildingName: '',
                floor: '',
                floorName: '',
                room: [],
                roomSelected: [],
                floorData: [],
                roomData: [],
                loading: {
                    building: false,
                    floor: false,
                    room: false,
                },
            });
        },
        addReductionPolicy(ev) {
            if (ev && (ev.value ?? '') !== '') {
                ev.data.forEach(item => {
                    if (item[ev.valueKey] === ev.value) {
                        this.reductionPolicy.push({
                            reductionPolicyTitle: item.reduction_policy_title,
                            reductionPolicyId: item.reduction_policy_id,
                        });
                    }
                });
            }
            this.showAddReductionPolicy = false;
        },

        getDetail() {
            if (this.id) {
                this.pageLoading = true;
                this.getRoomList();
                getMetaCommonDetail('wisdom_park.wp_sublessor_contract', {
                    pk: 'id',
                    id: this.id,
                }).then(res => {
                    let form = res.data.data;
                    this.pageLoading = false;
                    this.form = form;
                });
            }
        },
        getRoomList() {
            let obj = {
                current: 1,
                size: 100,
                wheres: [{ field: 'sublessor_contract_id', value: this.id }],
            };
            getMetaCommonList('wisdom_park.wp_sublessor_contract_subject', obj).then(res => {
                const data = res.data.data;
                let datas = [];
                data.records.forEach(e => {
                    datas.push({
                        id: e.id,
                        room: e.room_id,
                        building: e.building_id,
                        buildingName: e.building_name,
                        floor: e.floor_id,
                        floorName: e.floor_name,
                        room_name: e.room_name,
                    });
                });
                this.selectRoomList = datas;
                this.oldSelectRoomList = JSON.parse(JSON.stringify(this.selectRoomList));
                let len = 0;
                this.selectRoomList.forEach((item, index) => {
                    this.getFloor(index, true).then(res => {
                        this.roomSelectChange(item, 'floor');
                    });
                    this.getRoom(index, true).then(res => {
                        len += this.selectRoomList[index].room.length;
                        if (len >= this.roomSelected.length) {
                            this.roomSelectChange(null, 'room');
                        }
                    });
                });
            });
        },
        getDetail1() {
            if (this.id) {
                this.pageLoading = true;
                detail({ id: this.id })
                    .then(res => {
                        if (res.data) {
                            let form = {};
                            Object.keys(res.data.data).forEach(keyName => {
                                let name = keyName.replace(/([A-Z])/g, '_$1').toLowerCase();
                                if (name !== 'contract_subjects') {
                                    form[name] = res.data.data[keyName];
                                } else {
                                    this.setRoomList(res.data.data[keyName]);
                                }
                            });
                            Object.keys(this.form).forEach(keyName => {
                                if (typeof form[keyName] === 'undefined') {
                                    form[keyName] = this.form[keyName];
                                }
                            });
                            this.reductionPolicy = form.contract_reduction_policies || [];
                            this.form = this.handleForm(form);
                            this.initRelations.forEach(item => {
                                if (
                                    this.form[item.code] !== '' &&
                                    this.form[item.code] !== null &&
                                    this.form[item.code] !== undefined
                                ) {
                                    this.getInitModel(this.form[item.code], item.model, item.prop);
                                }
                            });
                            if (!this.form['id']) {
                                this.calculate();
                            } else {
                                this.queryCollectionPlan();
                            }
                            this.modelChange('collection_account_id', 'collection_account', [
                                { code: '$account_bank', name: 'account_bank' },
                                { code: '$collection_account', name: 'collection_account' },
                            ]);
                            this.pageLoading = false;
                        }
                    })
                    .catch(e => {
                        this.pageLoading = false;
                        this.$message.error('数据加载失败，请重新加载');
                        this.$emit('close');
                    });
            }
        },
        handleForm(form) {
            if (form) {
                Object.keys(form).forEach(key => {
                    if (typeof this.form[key] === 'string') {
                        form[key] = `${form[key] === null ? '' : form[key]}`;
                    }
                });
            }
            if (this.isRelet || this.isTemplate) {
                form['start_date'] = dayjs(form.end_date).format('YYYY-MM-DD');
                form['end_date'] = dayjs(form.start_date).add(form['rent_period'], 'month').format('YYYY-MM-DD');
                form['signed_date'] = dayjs().format('YYYY-MM-DD');
                form['fix_date'] = '';
                form['fix_notice'] = null;
                form['rent_free_period'] = null;
                form['rent_free_start_date'] = '';
                form['rent_free_end_date'] = '';
                form['code'] = '';
                form['attachment_ids'] = '';
                delete form['id'];
                [{ start: 'start_date', end: 'end_date', prop: 'rent_period' }].forEach(item => {
                    this.calculateEndData(item.start, item.end, item.prop);
                });
            }
            if (this.isRelet) {
                form['contract_attribute'] = '2';
            }
            return form;
        },
        save(storage) {
            this.saveLoading = true;
            let body = {
                ...this.form,
                contractSubjects: this.roomSelected,
                collectionPlans: this.feeData,
                contractReductionPolicies: this.reductionPolicy.map(item => {
                    let newItem = {
                        ...item,
                    };
                    if (this.form.id) {
                        newItem['contractId'] = this.form.id;
                    }
                    return newItem;
                }),
                storage: storage,
                deposit_resource: this.form.deposit_resource,
            };
            [
                { code: 'start_date', type: 1 },
                { code: 'end_date', type: 2 },
                { code: 'fix_date', type: 1 },
            ].forEach(item => {
                let val = body[item.code].split(' ')[0];
                if (val) {
                    body[item.code] = item.type === 1 ? `${val} 00:00:00` : `${val} 23:59:59`;
                }
            });
            delete body['reduction_policy_list'];
            (body.id ? update : save)(body)
                .then(res => {
                    if (storage == 1) {
                        if (res.data.data.offerType == 1) {
                            this.startFlow(res.data.data);
                        } else {
                            this.saveLoading = false;
                            this.$message.success('保存成功');
                            this.$emit('save');
                        }
                    } else {
                        this.saveLoading = false;
                        this.$message.success('保存成功');
                        this.$emit('save');
                    }
                })
                .catch(e => {
                    this.saveLoading = false;
                });
        },
        calculate() {
            if (this.isBusiness) {
                return;
            }
            if (this.form['collection_plan_strategy'] == 2) {
                return;
            }
            let body = {
                ...this.form,
                contractSubjects: this.roomSelected,
                contractReductionPolicies: this.reductionPolicy.map(item => {
                    let newItem = {
                        ...item,
                    };
                    if (this.form.id) {
                        newItem['contractId'] = this.form.id;
                    }
                    return newItem;
                }),
                deposit_resource: this.form.deposit_resource,
            };
            [
                { code: 'start_date', type: 1 },
                { code: 'end_date', type: 2 },
                { code: 'fix_date', type: 1 },
            ].forEach(item => {
                if (body[item.code]) {
                    let val = body[item.code].split(' ')[0];
                    body[item.code] = item.type === 1 ? `${val} 00:00:00` : `${val} 23:59:59`;
                }
            });
            if (!this.form.start_date || !this.form.end_date) {
                this.feeData = { deposit: [], rent: [] };
                return false;
            }
            if (this.form.rent_free_period && (!this.form.rent_free_start_date || !this.form.rent_free_end_date)) {
                this.feeData = { deposit: [], rent: [] };
                return false;
            }
            if (!this.roomSelected.length) {
                this.feeData = { deposit: [], rent: [] };
                return false;
            }
            delete body['reduction_policy_list'];
            delete body['reduction_policy_ids'];
            calculate(body).then(res => {
                if (res.data.data) {
                    this.feeData = res.data.data.rent
                        ? res.data.data
                        : {
                              deposit: [],
                              rent: [],
                          };
                    this.form.amount = this.getAllMoney(this.feeData.rent, true);
                }
            });
        },
        getMetaCommonList(code, prop, params) {
            return getMetaCommonList(`wisdom_park.${code}`, {
                current: 1,
                size: 500,
                ...params,
            }).then(res => {
                if (res.data && res.data.data && prop) {
                    this.dictData[prop] = res.data.data.records;
                }
                return res;
            });
        },
        getFloor(index, notClear) {
            console.log(index);
            return new Promise((resolve, reject) => {
                let building = this.selectRoomList[index].building;
                if (!notClear) {
                    this.selectRoomList[index].floor = '';
                    this.selectRoomList[index].floorData = [];
                    this.selectRoomList[index].room = [];
                    this.selectRoomList[index].roomData = [];
                }
                if (building) {
                    // console.log(this.selectRoomList[index]);
                    // this.selectRoomList[index].loading.floor = true;
                    this.getMetaCommonList('wp_floor', null, {
                        wheres: [{ field: 'building_id', value: building }],
                        orders: [{ field: 'code+1000', sort: 'DESC' }],
                    })
                        .then(res => {
                            if (res.data && res.data.data) {
                                // this.selectRoomList[index].loading.floor = false;
                                this.selectRoomList[index].floorData = res.data.data.records.map(item => {
                                    return {
                                        ...item,
                                        name: item.name ? item.name : `${item.code}层`,
                                    };
                                });
                                this.floorData = this.selectRoomList[index].floorData;
                                this.$forceUpdate();
                                this.selectRoomList = JSON.parse(JSON.stringify(this.selectRoomList));
                            }
                            resolve();
                        })
                        .catch(e => {
                            reject(e);
                        });
                }
            });
        },
        getRoom(index, notClear) {
            return new Promise((resolve, reject) => {
                let building = this.selectRoomList[index].building,
                    floor = this.selectRoomList[index].floor;
                if (!notClear) {
                    this.selectRoomList[index].roomData = [];
                    this.selectRoomList[index].room = [];
                }
                let getDisabled = item => {
                    // item.status !== 0
                    if (this.roomSelectSwitch) {
                        if (this.roomSelected.find(a => a.room_id === item.id)) {
                            return false;
                        } else {
                            return item.status !== 0;
                        }
                    } else {
                        return false;
                    }
                };
                if (building && floor) {
                    // this.selectRoomList[index].loading.room = true;
                    this.getMetaCommonList('wp_room', null, {
                        wheres: [
                            { field: 'building_id', value: building },
                            { field: 'floor_id', value: floor },
                            { field: 'is_cancel', value: '0' },
                        ],
                    })
                        .then(res => {
                            const statusType = {
                                0: '未租',
                                1: '已租',
                                2: '已售',
                                3: '自用',
                            };
                            //this.selectRoomList[index].loading.room = false;
                            if (res.data && res.data.data) {
                                let rooms = {};
                                (res.data.data.records || []).forEach(item => {
                                    if (!item.parent_id) {
                                        let disabled = getDisabled(item);
                                        rooms[item.id] = {
                                            ...item,
                                            disabled: disabled,
                                            name: disabled ? `【${statusType[item.status]}】${item.name}` : item.name,
                                        };
                                    }
                                });
                                (res.data.data.records || []).forEach(item => {
                                    if (item.parent_id) {
                                        let disabled = getDisabled(item);
                                        rooms[item.parent_id]['children'] = rooms[item.parent_id]['children'] || [];
                                        rooms[item.parent_id].children.push({
                                            ...item,
                                            disabled: disabled,
                                            name: disabled ? `【${statusType[item.status]}】${item.name}` : item.name,
                                        });
                                        rooms[item.parent_id]['children'] = rooms[item.parent_id]['children'].sort(
                                            (a, b) => (b.disabled ? -1 : 1),
                                        );
                                    }
                                });
                                this.selectRoomList[index].roomData = Object.values(rooms).sort((a, b) =>
                                    b.disabled ? -1 : 1,
                                );
                                this.selectRoomList = JSON.parse(JSON.stringify(this.selectRoomList));
                            }
                            resolve();
                        })
                        .catch(e => {
                            reject;
                        });
                }
            });
        },
        getInitModel(id, model, prop) {
            this.getMetaCommonList(model, prop, {
                wheres: [{ field: 'id', value: id }],
            });
        },
        searchModel(queryStr, modelCode, prop, searchFieldName) {
            let params = {};
            if (queryStr) {
                params = {
                    wheres: [{ field: searchFieldName || 'name', op: 'LIKE', value: queryStr }],
                };
            }
            this.loading[prop + 'Loading'] = true;
            this.getMetaCommonList(modelCode, prop, params).then(res => {
                this.loading[prop + 'Loading'] = false;
            });
        },
        getDictData() {
            getDictionary({
                code: 'RoomSelectSwitch',
            }).then(res => {
                (res.data.data || []).forEach(item => {
                    if (item.dictValue === 'SwitchOption') {
                        this.roomSelectSwitch = item.dictKey === '1' ? true : false;
                    }
                });
            });
            [
                { code: 'ContractAttribute', prop: 'contract_attribute' },
                { code: 'ReceiptStrategy', prop: 'receipt_strategy' },
                { code: 'OfferType', prop: 'offer_type' },
                // {code: 'PaymentType' , prop: 'payment_type'},
                { code: 'FREQUENCY_UNIT', prop: 'frequency_unit' },
                { code: 'PropertyFeeWay', prop: 'property_fee_way' },
                { code: 'DepositPayStatus', prop: 'deposit_pay_status' },
            ].forEach(item => {
                getDictionary({
                    code: item.code,
                }).then(res => {
                    if (res.data && res.data.data) {
                        this.dictData[item.prop] = res.data.data;
                    }
                });
            });
            [
                { code: 'wp_building', prop: 'building' },
                { code: 'wp_collection_account', prop: 'collection_account' },
                // {code: 'wp_contract_template' , prop: 'template'}
            ].forEach(item => {
                this.getMetaCommonList(item.code, item.prop).then(res => {
                    if (this.id && item.code === 'wp_collection_account') {
                        this.modelChange('collection_account_id', 'collection_account', [
                            { code: '$account_bank', name: 'account_bank' },
                            { code: '$collection_account', name: 'collection_account' },
                        ]);
                    }
                });
            });
        },
        modelChange(idName, dictName, props) {
            let data = [];
            if (typeof dictName === 'object') {
                data = dictName.data || [];
            } else {
                data = this.dictData[dictName];
            }
            data.forEach(item => {
                if (item.id === this.form[idName]) {
                    if (Array.isArray(props)) {
                        props.forEach(prop => {
                            if (this.cache[prop.code] !== undefined) {
                                this.cache[prop.code] = item[prop.name] || '';
                            } else {
                                this.form[prop.code] = item[prop.name] || '';
                            }
                        });
                    }
                }
            });
        },
        saveEnterpriseForm(data) {
            this.form.company_id = data.id;
            this.form.renters_name = data.name;
            this.form.corporation_personality_contact = data.legal_contact;
            this.form.corporation_personality = data.legal_person;
            this.searchModel(data.name, 'wp_enterprise', 'enterprise');
            this.enterpriseDrawer = false;
        },
        roomSelectChange(row, name) {
            let data = [];
            if (name === 'room') {
                this.calculateRoom();
            } else {
                if (name === 'building') {
                    data = this.dictData.building;
                } else {
                    data = row[`${name}Data`] || [];
                }
                if (data) {
                    data.forEach(item => {
                        if (item.id === row[name]) {
                            row[`${name}Name`] = item.name;
                        }
                    });
                }
            }
        },
        findRoom(roomData, roomId) {
            let result = null;
            roomData.forEach(room => {
                if (room.id === roomId) {
                    result = room;
                }
                if (!result && room.children) {
                    room.children.forEach(childrenItem => {
                        if (childrenItem.id === roomId) {
                            result = childrenItem;
                        }
                    });
                }
            });
            return result;
        },
        calculateRoom() {
            let roomSelected = [];
            this.selectRoomList.forEach(itemRoom => {
                console.log(itemRoom);
                itemRoom.roomData.forEach(itemRoomId => {
                    let currentRoom = this.findRoom(itemRoom.roomData, itemRoomId);
                    if (currentRoom && !roomSelected.find(item => item.room_id === currentRoom.id)) {
                        let currentBuilding = this.dictData.building.find(item => item.id === itemRoom.building);
                        let oldRoomItem = this.roomSelected.find(item => item.room_id === currentRoom.id) || {};
                        if (currentRoom && currentBuilding) {
                            let tempFee = 0;
                            if (oldRoomItem.property_management_fee >= 0) {
                                tempFee = oldRoomItem.property_management_fee;
                            } else {
                                tempFee = currentBuilding.property_management_fee
                                    ? currentBuilding.property_management_fee
                                    : 0;
                            }
                            let roomObj = {
                                building_id: itemRoom.building,
                                building_name: itemRoom.buildingName,
                                floor_id: itemRoom.floor,
                                floor_name: itemRoom.floorName,
                                room_id: currentRoom.id,
                                room_name: currentRoom.name,
                                room_area: oldRoomItem.room_area || currentRoom.room_area || 0,
                                rental_unit_price_day:
                                    oldRoomItem.rental_unit_price_day || currentRoom.rental_unit_price_day || 0,
                                incremental_unit_price:
                                    oldRoomItem.incremental_unit_price || currentRoom.incremental_unit_price || 0,
                                incremental_identification:
                                    oldRoomItem.incremental_identification ||
                                    currentRoom.incremental_identification ||
                                    1,
                                // property_management_fee: oldRoomItem.property_management_fee || currentBuilding.property_management_fee ||  0,
                                property_management_fee: tempFee,
                                amount: 0,
                                start_date:
                                    oldRoomItem.start_date ||
                                    (this.form.start_date ? dayjs(this.form.start_date).format('YYYY-MM-DD') : null),
                                end_date:
                                    oldRoomItem.end_date ||
                                    (this.form.end_date ? dayjs(this.form.end_date).format('YYYY-MM-DD') : null),
                            };
                            roomSelected.push(roomObj);
                        }
                    }
                });
            });
            this.roomSelected = roomSelected;
        },
        getFreeDay(start_date, end_date) {
            let freeDay = 0;
            let rent_free_start_date = dayjs(this.form.rent_free_start_date),
                rent_free_end_date = dayjs(this.form.rent_free_end_date);
            if (rent_free_end_date.valueOf() >= start_date.valueOf()) {
                let current_rent_free_end_date =
                    rent_free_end_date.valueOf() < end_date.valueOf() ? rent_free_end_date : end_date;
                if (rent_free_start_date.valueOf() < start_date.valueOf()) {
                    freeDay = dayjs(current_rent_free_end_date).diff(start_date, 'day');
                } else if (
                    rent_free_start_date.valueOf() >= start_date.valueOf() &&
                    rent_free_start_date.valueOf() < end_date.valueOf()
                ) {
                    freeDay = dayjs(current_rent_free_end_date).diff(rent_free_start_date, 'day');
                } else {
                    freeDay = 0;
                }
            }
            return freeDay;
        },
        getIncreasePrice(start_date, price) {
            let year_increase = this.form.year_increase || null,
                increase_rate = this.form.increase_rate || null,
                current_year_increase = 0,
                oldPrice = price,
                increase_price = 0;
            if (year_increase && increase_rate) {
                let increase_time = dayjs(this.form.start_date).add(year_increase, 'year');
                if (start_date.valueOf() >= increase_time.valueOf()) {
                    current_year_increase = Math.ceil((start_date.diff(increase_time, 'month') + 1) / 12);
                    if (current_year_increase) {
                        price =
                            price *
                            Math.pow(mathjs.chain(increase_rate).divide(100).add(1).done(), current_year_increase);
                        increase_price = mathjs.chain(price).subtract(oldPrice).done();
                    }
                }
            }
            return {
                price: price,
                increase_price: increase_price,
            };
        },
        calculateEndData(startName, endName, valueName) {
            if (this.form[valueName] !== null && this.form[startName]) {
                this.form[endName] = dayjs(this.form[startName])
                    .add(this.form[valueName], 'M')
                    .subtract(1, 'day')
                    .format('YYYY-MM-DD');
            }
        },
        set_init_date(prop, endName, valueName) {
            let start_date = dayjs(this.form.start_date);
            if (!this.form[prop]) {
                this.form[prop] = start_date.format('YYYY-MM-DD');
            }
            if (prop && endName && valueName) {
                this.calculateEndData(prop, endName, valueName);
            }
        },
        startFlow(row) {
            startFlow(row.id, this.$PCode.BIZ.CONTRACT, this.$PCode.ACTIONS.SUBMIT, {
                companyName: row.rentersName,
                roomName: row.roomName,
            }).then(() => {
                this.saveLoading = false;
                this.$message.success('保存成功');
                this.$emit('save');
            });
        },
        setRoomList(roomList) {
            let floors = {},
                roomSelected = [];
            roomList.forEach(item => {
                if (!floors[item.floorId]) {
                    floors[item.floorId] = {
                        building: item.buildingId,
                        buildingName: item.buildingName,
                        floor: item.floorId,
                        floorName: '',
                        room: [],
                        roomSelected: [],
                        floorData: [],
                        roomData: [],
                        loading: {
                            building: false,
                            floor: false,
                            room: false,
                        },
                    };
                }
                floors[item.floorId].room.push(item.roomId);
                roomSelected.push({
                    room_id: item.roomId,
                    room_area: item.roomArea,
                    rental_unit_price_day: parseFloat(item.rentalUnitPriceDay),
                    property_management_fee: parseFloat(item.propertyManagementFee),
                    start_date: item.startDate || null,
                    end_date: item.endDate || null,
                    incremental_unit_price: item.incrementalUnitPrice,
                    incremental_identification: item.incrementalIdentification || 1,
                });
            });
            this.roomSelected = roomSelected;
            this.selectRoomList = Object.values(floors);
            let len = 0;
            this.selectRoomList.forEach((item, index) => {
                this.getFloor(index, true).then(res => {
                    console.log(res);
                    this.roomSelectChange(item, 'floor');
                });
                this.getRoom(index, true).then(res => {
                    len += this.selectRoomList[index].room.length;
                    if (len >= this.roomSelected.length) {
                        this.roomSelectChange(null, 'room');
                    }
                });
            });
        },
        getAllMoney(data, isList) {
            if (isList) {
                let amount = 0;
                data.forEach(item => {
                    amount = mathjs
                        .chain(amount)
                        .add(item.propertyManagementFeeTotal || 0)
                        .add(item.amountReceivable || 0)
                        .done();
                });
                return amount;
            } else {
                return mathjs.add(data.propertyManagementFeeTotal || 0, data.amountReceivable || 0);
            }
        },
        setEditMoney() {
            this.$confirm(
                '修改当期应收金额可能会导致应收总额与金额条款内的租金总额和租金预览不相等,需要手动修改租金总额,确定继续吗？',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                },
            )
                .then(() => {
                    Object.values(this.feeData).forEach(val => {
                        val.forEach(item => {
                            ['propertyManagementFeeTotal', 'amountReceivable'].forEach(name => {
                                item[name + '_old'] = item[name];
                            });
                        });
                    });
                    this.editMoney = true;
                })
                .catch(() => {
                    this.editMoney = false;
                });
        },
        cancelEditMoney(save) {
            Object.values(this.feeData).forEach(val => {
                val.forEach(item => {
                    ['propertyManagementFeeTotal', 'amountReceivable'].forEach(name => {
                        if (!save) {
                            item[name] = item[name + '_old'];
                        }
                        delete item[name + '_old'];
                    });
                });
            });
            this.editMoney = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.manageForm {
    /deep/.el-dialog__body {
        height: calc(90vh - 110px);
        overflow: auto;
        padding: 15px;
    }
    /deep/.el-dialog__footer {
        text-align: left;
        padding: 0;
    }
    /deep/.el-input-group__append,
    /deep/.el-input-group__prepend {
        padding: 0 10px;
    }
    .input-with-select {
        /deep/.el-input {
            width: 80px;
        }
    }
}
.contract_form {
    /deep/.el-select {
        width: 100%;
    }
}
</style>